import materaLakeside10_1 from "./7.png";
import materaLakeside10_2 from "./8.png";
import materaLakeside10_3 from "./9.png";
import materaLakeside10_4 from "./10.png";

const materaLakeside10 = [
  materaLakeside10_1,
  materaLakeside10_2,
  materaLakeside10_3,
  materaLakeside10_4,
];

export default materaLakeside10;
